const ID_SEGMENT_PATTERN = /^[A-Za-z0-9_-]+$/;

/**
 * True when `value` is safe to use as one URL path segment for an API-issued
 * id (cuid / uuid charset). Notably rejects `.` and `..`, which survive
 * `encodeURIComponent` and which the browser resolves to another route.
 */
export function isIdSegment(value: string): boolean {
  return ID_SEGMENT_PATTERN.test(value);
}

/**
 * `value` itself when it is safe as one URL path segment, otherwise a thrown
 * error. For ids that arrive in API payloads and are interpolated into a
 * request path: a hostile `..` must fail loudly instead of re-routing the call.
 */
export function assertIdSegment(value: string, label: string): string {
  if (!isIdSegment(value)) throw new Error(`Refusing to use an unsafe ${label} in a request path`);
  return value;
}
